module.exports = __webpack_public_path__ + "02_short_grey.c4c704c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_short_grey.png
// module id = KS6C
// module chunks = 0